module.exports = __webpack_public_path__ + "static/media/ic_basket.e446db4f.svg";